module.exports = __webpack_public_path__ + "img/bg-card-cero@3x.8868c545.png";